export const MAGIC_LINK_STORAGE_TOKEN_KEY = 'shipperguide-all-in-one-user-token'
